import cx from 'classnames'

export const Figures = ({ accentFirst = true, className, items = [], ...props }) => (
  <div className={cx('tw:flex tw:items-end tw:gap-10 tw:mobile:grid tw:mobile:grid-cols-3 tw:mobile:gap-4', className)} {...props}>
    {items.map((item, index) => (
      <div className="tw:flex tw:min-w-[92px] tw:flex-col tw:gap-1" key={item.label}>
        <span
          className={cx(
            'tw:text-5xl tw:font-light tw:tabular-nums tw:text-foreground-strong',
            accentFirst && index === 0 && 'tw:text-accent',
          )}
        >
          {item.value}
        </span>
        <span className="ds-caption">{item.label}</span>
      </div>
    ))}
  </div>
)
